module.exports = __webpack_public_path__ + "static/media/handlingKit.be49db84.jpg";